import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as styles from './Tag.module.scss'

const Tag = ({ children, className: additionalClassName }) => {
  const className = classNames(styles.Tag, additionalClassName)

  return (
    <span className={className} data-qa="tag">
      {children}
    </span>
  )
}

Tag.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export { Tag }
export default Tag
